import React from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaGlobe, FaFax, FaRegAddressCard } from 'react-icons/fa';

const orgDetails = {
    address: "1418, Pusedavali Road, Kadepur, Kadegaon, Sangli, Maharashtra 415305",
    email: ["prutvisangram@rediffmail.com", "ydadasaheb@gmail.com"],
    phone: "",
    fax: "02347-241365",
    mobile: ["9960690606", "7219597516"],
    website: "www.pruthvisangram.org",
    weatherTrustorSociety: "Both",
    trustRegistration: "F9430 Date 26/04/2006",
    societyRegistration: "MAH/9295/2003 Date 04/03/2003",
    ngoDarpanRegNo: "UNIQUEID:MH/2017/0160233",
    mcaCsrRegNo: "CSR00010032",
    twelveAA: "Tech/12AA/Pune Rg./155/603/2017-18/4373/ Date-09/11/2017",
    eightyG: "Tech/80G./436/2018-19/6178/ Date-18/12/2018",
    operationalArea: "Sangli, Satara, Kolhapur, Solapur, Ratnagiri, Raigad, Sindhudurg, Pune, Ahmednagar, Osmanabad, Yavatmal District of Maharashtra and Goa State",
};

const ContactUs = ({ darkMode }) => {
    const cardStyle = {
        backgroundColor: darkMode ? '#343a40' : '#ffffff',
        color: darkMode ? '#f8f9fa' : '#212529',
        border: darkMode ? '1px solid #495057' : '1px solid #dee2e6'
    };

    const listItemStyle = {
        backgroundColor: 'transparent',
        color: 'inherit',
        borderColor: darkMode ? '#495057' : '#dee2e6'
    };

    return (
        <Container style={{ minHeight: '100vh', paddingTop: '30px', paddingBottom: '30px' }}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className="text-center mb-2" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                    Contact Us
                </h2>
                <p className="text-center mb-4" style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.05rem' }}>
                    Pruthvisangram Gramvikas Sanstha (PSGS) is a dedicated non-governmental organization committed to
                    fostering sustainable rural development. Founded in 2003, PSGS functions as a multifaceted organization,
                    simultaneously serving as a technical service provider, a project implementation agency, and a training
                    and capacity-building institution.
                </p>
            </motion.div>

            <Row className="mb-4">
                <Col md={6} className="mb-4">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        style={{ height: '100%' }}
                    >
                        <Card style={cardStyle} className="shadow h-100">
                            <Card.Body>
                                <Card.Title style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                                    Get in Touch
                                </Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item style={listItemStyle}>
                                        <FaMapMarkerAlt className="me-2" style={{ color: '#2E7D32' }} />
                                        <strong>Address:</strong> {orgDetails.address}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <FaEnvelope className="me-2" style={{ color: '#2E7D32' }} />
                                        <strong>Email:</strong> {orgDetails.email.join(", ")}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <FaFax className="me-2" style={{ color: '#2E7D32' }} />
                                        <strong>Fax:</strong> {orgDetails.fax}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <FaPhoneAlt className="me-2" style={{ color: '#2E7D32' }} />
                                        <strong>Mobile:</strong> {orgDetails.mobile.join(", ")}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <FaGlobe className="me-2" style={{ color: '#2E7D32' }} />
                                        <strong>Website:</strong> {orgDetails.website}
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </motion.div>
                </Col>
                <Col md={6} className="mb-4">
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                        style={{ height: '100%' }}
                    >
                        <Card style={cardStyle} className="shadow h-100">
                            <Card.Body>
                                <Card.Title style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                                    Registration Details
                                </Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item style={listItemStyle}>
                                        <FaRegAddressCard className="me-2" style={{ color: '#2E7D32' }} />
                                        <strong>Trust or Society:</strong> {orgDetails.weatherTrustorSociety}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <strong>Trust Registration:</strong> {orgDetails.trustRegistration}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <strong>Society Registration:</strong> {orgDetails.societyRegistration}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <strong>NGO Darpan Reg. No.:</strong> {orgDetails.ngoDarpanRegNo}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <strong>MCA – CSR Reg. No.:</strong> {orgDetails.mcaCsrRegNo}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <strong>12AA:</strong> {orgDetails.twelveAA}
                                    </ListGroup.Item>
                                    <ListGroup.Item style={listItemStyle}>
                                        <strong>80G:</strong> {orgDetails.eightyG}
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </motion.div>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                    >
                        <Card style={{ ...cardStyle, borderLeft: '4px solid #2E7D32' }} className="shadow-sm">
                            <Card.Body>
                                <h5 style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>Current Operational Area</h5>
                                <p className="mb-0">{orgDetails.operationalArea}</p>
                            </Card.Body>
                        </Card>
                    </motion.div>
                </Col>
            </Row>
        </Container>
    );
};

export default ContactUs;
